"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomeFarming = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var DomeFarming = (function (_super) {
    __extends(DomeFarming, _super);
    function DomeFarming() {
        return _super.call(this, {
            name: CardName_1.CardName.DOME_FARMING,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.BUILDING],
            productionBox: Units_1.Units.of({ megacredits: 2, plants: 1 }),
            metadata: {
                cardNumber: 'P07',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(2).plants(1); });
                }),
                description: 'Increase your M€ production 2 steps and plant production 1 step.',
            },
        }) || this;
    }
    DomeFarming.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        return undefined;
    };
    return DomeFarming;
}(PreludeCard_1.PreludeCard));
exports.DomeFarming = DomeFarming;
//# sourceMappingURL=DomeFarming.js.map